import React, { FunctionComponent } from "react";
import styles from "./Product.module.scss";
import ProductContent from "./ProductContent.model";

import Anchor from "components/Anchor/Anchor";
import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import IconViewer from "components/IconViewer/IconViewer";
import ImageViewer from "components/ImageViewer/ImageViewer";

const Product: FunctionComponent<ProductContent> = (props) => {
    const media = props?.media;
    const imageCrop = getImageCrop(media?.crops, undefined, "Square (1:1)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, media?.width, media?.height);

    return (
        <div className={styles.wrapper}>
            <Anchor
                className={styles.link}
                to={props?.links ? props?.links[0]?.link : ""}
            >
                <div className={styles.content}>
                    {/* Tagline */}
                    <span className={styles.tagline}>{props?.tagline}</span>
                    {/* Headline */}
                    <h3 className={styles.headline}>{props?.headline}</h3>

                    <IconViewer
                        className={styles.arrow}
                        name="arrowRight"
                        heightRatio={10.848 / 31.519}
                    />
                </div>

                {/* Media */}
                <div className={styles.media}>
                    {media !== null ? (
                        <ImageViewer
                            className={styles.image}
                            src={media?.url || media}
                            crop={imageCrop}
                            focalPoint={media?.focalPoint}
                            {...imageAspectRatio}
                            alt={""}
                        />
                    ) : null}
                </div>
            </Anchor>
        </div>
    );
};

export default Product;
